/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import classNames from 'classnames';
import { Modal, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

// Style
import './ErrorModal.scss';

// Components
import Typography from '../../atoms/Typography';
import Button from '../../atoms/Button';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

const ErrorModal = (props) => {
  /* ******************************** LOGIC ******************************* */

  const { opened, onClose, subTitle, message, buttonText, contactUrl } = props;

  const theme = useMantineTheme();

  const isMobileOrTablet = useMediaQuery(`(max-width:${theme.breakpoints.smDesktop}px)`);

  /* ******************************** RENDERING ******************************* */

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
      centered
      padding="0px"
      overlayBlur={3}
      overlayColor="rgba(128, 130, 133, 0.4)"
      classNames={{
        root: 'error-modal-root',
        inner: 'error-modal-root__inner',
        modal: 'error-modal-root__inner__modal',
      }}>
      <div className="error-modal-wrapper">
        {/* SubTitle */}
        <div className="error-modal-wrapper__subtitle-ctn">
          <Typography type="subtitle" mb={isMobileOrTablet ? '10px' : '12px'}>
            {subTitle}
          </Typography>
        </div>

        {/* Message */}
        <Typography type="text" mb="20px">
          {message}
          {contactUrl && (
            <a
              className="error-modal-wrapper__contact-link"
              href={contactUrl}
              target="_blank"
              rel="noopener noreferrer">
              {contactUrl}
            </a>
          )}
        </Typography>

        {/* Close button */}
        <div className={classNames('error-modal-wrapper__btn-ctn', 'centred')}>
          <Button disableMarginBottom onClick={onClose}>
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
